/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * MCP approval response item: The decision payload for a prior MCP approval request.
 */
export type MCPApprovalResponse = {
  type: "mcp_approval_response";
  approvalRequestId: string;
  approve: boolean;
  id?: string | undefined;
  reason?: string | undefined;
};

/** @internal */
export const MCPApprovalResponse$inboundSchema: z.ZodType<
  MCPApprovalResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("mcp_approval_response"),
  approval_request_id: z.string(),
  approve: z.boolean(),
  id: z.string().optional(),
  reason: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "approval_request_id": "approvalRequestId",
  });
});
/** @internal */
export type MCPApprovalResponse$Outbound = {
  type: "mcp_approval_response";
  approval_request_id: string;
  approve: boolean;
  id?: string | undefined;
  reason?: string | undefined;
};

/** @internal */
export const MCPApprovalResponse$outboundSchema: z.ZodType<
  MCPApprovalResponse$Outbound,
  z.ZodTypeDef,
  MCPApprovalResponse
> = z.object({
  type: z.literal("mcp_approval_response"),
  approvalRequestId: z.string(),
  approve: z.boolean(),
  id: z.string().optional(),
  reason: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    approvalRequestId: "approval_request_id",
  });
});

export function mcpApprovalResponseToJSON(
  mcpApprovalResponse: MCPApprovalResponse,
): string {
  return JSON.stringify(
    MCPApprovalResponse$outboundSchema.parse(mcpApprovalResponse),
  );
}
export function mcpApprovalResponseFromJSON(
  jsonString: string,
): SafeParseResult<MCPApprovalResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MCPApprovalResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MCPApprovalResponse' from JSON`,
  );
}
